module.exports = __webpack_public_path__ + "static/assets/e74c9927524c26d38d74b4bbe9162575.png";